<template>
  <div>
    <com-header></com-header>
    <div class="user-center-container">
      <div class="main">
        <div class="left-menu">
          <side-menu :side-list="sideList"></side-menu>
        </div>
        <div class="right-content">
          <div class="headline">
            <head-title :h-title="hTitle"></head-title>
          </div>
          <router-view @handleHtitle="handleHtitle"></router-view>
        </div>
      </div>
    </div>
    <home-service></home-service>
    <com-footer></com-footer>
  </div>
</template>

<script>
import sideMenu from './components/SideMenu'
import headTitle from './components/HeadTitle'
import HomeService from '../../components/HomeService'
const sideList = [
  // {
  //   index: 0,
  //   title: '个人信息',
  //   link: 'personInfo'
  // },
  // {
  //   index: 1,
  //   title: '我的求购',
  //   link: 'myPurchase'
  // },
  // {
  //   index: 2,
  //   title: '我的报价',
  //   link: 'QuotationManage'
  // },
  // {
  //   index: 3,
  //   title: '我的需求',
  //   link: 'DemandListMine'
  // },
  // {
  //   index: 4,
  //   title: '获取需求',
  //   link: 'DemandListPass'
  // },
  {
    index: 5,
    title: '我的需求',
    link: 'mineDemand'
  },
  {
    index: 6,
    title: '需求足迹',
    link: 'demandFootPrint'
  }
]
export default {
  name: 'UserCenter',
  components: { sideMenu, headTitle, HomeService },
  data() {
    return {
      sideList: sideList,
      hTitle: ''
    }
  },
  watch: {
    $route() {
      this.hTitle = this.$route.meta.headline
    }
  },
  created() {
    this.hTitle = this.$route.meta.headline
  },
  methods: {
    handleHtitle(title) {
      this.hTitle = title
    }
  }
}
</script>

<style lang="scss" scoped>
.user-center-container {
  width: 100%;
  margin-top: 10px;
  padding-bottom: 50px;
  background: #f8f8f8;
  .main {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    overflow: hidden;
  }
  .left-menu {
    width: 150px;
    min-height: 358px;
    background: #ffffff;
  }
  .right-content {
    width: 1040px;
    background: #ffffff;
  }
}
.contract-form,
.process-form,
.design-form,
.material-form,
.equipment-form,
.workTeam-form,
.worker-form {
  width: 70%;
  margin: 30px 0 100px 30px;
}
</style>
